import React, { useEffect, useMemo, useState } from 'react';
import styles from './tournament-item.module.scss';
import moment from 'moment';
import 'moment-timezone';
import { getTeamConfig, getEnvConfig } from '../../../config/config';
import { ITournaments } from '../../../graphql-types/tournaments';

interface ScheduleItemProps {
  data?: ITournaments;
}

const TournamentsItem: React.FC<ScheduleItemProps> = ({ data }) => {
  const [teamLogoLoaded, setTeamLogoLoaded] = useState(false);
  const teamUrl = getTeamConfig().teamUrl;
  const siteUrl = /\/$/.test(getEnvConfig().site) ? getEnvConfig().site : `${getEnvConfig().site}/`;


  // Some historic records have +01:00 in the timezone
  // Newer records are stored with +00:00
  // As the UI doesn't show the time for tournaments
  // Safest thing is to just drop the time portion
  if (data?.startDate instanceof Date) {
    data.startDate = data?.startDate .toISOString()
  }

  if (data?.startDate) {
    data.startDate = data.startDate.split('T')[0];
  }

  if (data?.endDate instanceof Date) {
    data.endDate = data?.endDate .toISOString()
  }

  if (data?.endDate) {
    data.endDate = data.endDate.split('T')[0];
  }
  
  const loaded = () => {
    setTeamLogoLoaded(true);
  };

  let teamLogo = useMemo(() => new Image(), []);
  teamLogo.src = `${siteUrl}${data?.parentOrganisation.organisationId}/Logo`;

  useEffect(() => {
    teamLogo.addEventListener('load', loaded);

    return () => {
      teamLogo.removeEventListener('load', loaded);
    };
  }, [teamLogo]);

  return (
    <div className={styles.tournamentItem}>
      <div className={styles.team}>
        {teamLogoLoaded && (
          <div className={styles.logo}>
            <a
              data-testid="PT-tournamentItem-logoTeamLink"
              href={`${teamUrl}${data?.parentOrganisation.organisationId}&a=Index&c=VenueTeam`}
            >
              <img src={teamLogo.src} alt={data?.parentOrganisation.organisationName} />
            </a>
          </div>
        )}
        <div className={styles.timeTeam}>
          <time>
            {moment(data?.startDate).format('MMM D (ddd), YYYY')} -{' '}
            {moment(data?.endDate).format('MMM D (ddd), YYYY')}
          </time>
          <p>
            <span>{data?.tournamentName}</span>
          </p>
        </div>
      </div>

      <div className={styles.location}>
        at
        <a href={`${teamUrl}${data?.parentOrganisation.organisationId}&a=Index&c=VenueTeam`}>
          {data?.parentOrganisation.organisationName}
        </a>
      </div>
      <div>
        <a
          data-testid="PT-tournamentItem-tournamentDetailsLink"
          href={`${siteUrl}Competitions/ITA/Tournaments/Overview/${data?.tournamentId}`}
          className={styles.boxLink}
        >
          View details
        </a>
      </div>
    </div>
  );
};

export default TournamentsItem;
